import { IUseFetchOptionsParams } from '@common/api.models';
import { FETCH_QUERIES_NAME } from '@common/constants';
import { createUseFetchOptionsNoPropsFn } from '@common/selectOptions.services';
import { getOrganizationTypesAsync } from './organizationType.services';

export const useFetchOrganizationTypes = ({ isDirty = false, shouldConvertOptions = true }: IUseFetchOptionsParams) =>
  createUseFetchOptionsNoPropsFn({
    queryName: FETCH_QUERIES_NAME.ORGANIZATION_TYPES,
    getOptionsFn: getOrganizationTypesAsync,
    handleOptionsProps: {
      shouldConvertOptions,
      textFieldName: 'displayName',
    },
    enabled: !isDirty,
  });
